import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const Task303: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-303');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-303">
        <h2>zadanie 3</h2>
        <h3>{task?.title}</h3>
        <p>
            Tiril i Oliver to dwoje młodych detektywów, którzy razem ze swoim psem rozwiązują zagadki, z którymi nie mogą poradzić sobie dorośli policjanci. Ich przygody opisuje Jørn Lier Horst w serii pt.: “Operacje”. Wcielcie się w rolę tych bohaterów i odkryjcie nieznane Wam dotychczas fakty, dotyczące Waszej biblioteki!
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> Udajcie się do Waszej biblioteki, żeby znaleźć odpowiedzi na zadane poniżej pytania:<br />
        </p>
        <div className="decor-1">
            <ol>
                <li>W którym roku powstała Wasza biblioteka?</li>
                <li>Ile jest w niej czasopism?</li>
                <li>Czy są w niej gry planszowe?</li>
                <li>Czy w Waszej bibliotece jest czytelnia naukowa?</li>
                <li>Jaka jest najstarsza książka w Waszej bibliotece?</li>
                <li>Ile jest tam roślin doniczkowych?</li>
                <li>Skąd Wasza biblioteka ma książki?</li>
                <li>Co przedstawia ekslibris Waszej biblioteki?</li>
                <li>Czy w Waszej bibliotece można robić coś poza wypożyczaniem książek?</li>
                <li>W jakie dni jest otwarta Wasza biblioteka?</li>
            </ol>
        </div>

    </div>
}

export default Task303;
